import Constant from "@constant/index.js";
import API from "@api/index.js";
import {$util, $event_publisher} from "@util/util.js";
import Intercept from "@observer/Intercept.js";
import Alert from "@util/alert.js";

export default class MainSkuWapView{
    constructor(model){
        this._model = model;
        this._model._view = this;
        //mainsku的容器
        this._el = null;
        //整个mainsku的容器（不同于group，主要为了区分满减-多个mainsku）
        this._fullMainSkuEl = null;

        this._headerBoxEl = null;
        this._extraBoxEl = null;

        //选择服务弹框
        this._serverBoxEl = null;
        // 选择优惠券弹框
        this._couponBoxEl = null;
        // 选择选件
        this._optionBoxEl = null;
        // 选择赠品
        this._giftBoxEl = null;
        // 找相似
        this._similarityBoxEl = null;
        //// 到货通知
        // this._arrivalgoodsBoxEl = null;
        //单品 --> mainSku._parent._headerBoxEl
        //套餐 --> mainSku._parent._headerBoxEl
        //选件 --> mainSku._parent._headerBoxEl
        //满减 --> mainSku._headerBoxEl
        this._eventCenter = new MainSkuEvent();
    }

    getAddPrice(){

        //套餐不用显示比价
        if (this._model._parent._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE) {
            return "";
        }
        //预售定金不用显示比价
        if (this._model._booking &&  this._model._booking._presellway == 2) {
            return "";
        }
        //失效商品
        if(this._model._parent._invalid){
            return ``; 
        }
        if (this._model._addPrice && this._model._invalid == false) {
            return `<p class="reduce_price le_tip_btn_border"><span tag='mainsku_addprice'>${this._model._addPrice}</span></p>`;
        }
        return "";      
    }

    getDeduction(){
        //失效商品
        if(this._model._parent._invalid){
            return ``; 
        }
        // 预售有定金抵扣时小计特殊处理
        if(this._model._booking && this._model._booking._presellway == 2 && this._model._booking._deduction != '待公布'){       
            return `<p class="reduce_price le_tip_btn_border">定金抵扣¥${this._model._booking._deduction}</p>`;
        }
        return "";      

    }

    getBookingInfo(){
        //失效商品
        if(this._model._parent._invalid){
            return ``; 
        }
        // 新增逻辑判断： 如果商品为全款支付开始前，展示“待公布”.接口无其他字段判断此状态，只能汉字判断
        if(this._model._booking &&  this._model._booking._deduction == '待公布') {
            return `<span>￥${this._model._price}</span>`;
        } else {
            // 预售有定金抵扣时价格显示特殊处理 _presellway： 1全款，2定金
            if(this._model._booking && this._model._booking._presellway == 2){       
                return `<span>定金¥</span>${this._model._booking._deposit}`;
            }else{
                if(this._model._deliveryPrice) {
                  return `<div class="with-delivery-price"><span>¥</span>${this._model._price}</div>`;
                }else {
                  return `<span>¥</span>${this._model._price}`;
                }
            }
        }

    }
    // 价格附注信息
    handlePriceRemarks(){
      const {
        subsidyPreIndex = '',
        subsidyCheckItemDesc = '',
        deliveryPricePreIndex = '',
        deliveryPrice = '',
      } = this._model._data;
      const { _deliveryPrice } = this._model;
      /* 
        有下单立减优惠或者优惠券优惠的国补品未选：展示“预估国补后xx元”
        有下单立减优惠或者优惠券优惠的国补品且是单品单选：展示“预估到手价xx元”
        有下单立减优惠或者优惠券优惠的国补品多品或多选：展示“国家补贴，至高减xx%”
        无下单立减优惠或者优惠券优惠的国补品未选：展示“预估国补后xx元”
        无下单立减优惠或者优惠券优惠的国补品单选：展示“国家补贴，至高减xx%”
        无下单立减优惠或者优惠券优惠的国补品多选：展示“国家补贴，至高减xx%”
      */
      const htmlKey = [
        { condition: subsidyPreIndex, value: 'subsidyPreIndex' },
        { condition: subsidyCheckItemDesc, value: 'subsidyCheckItemDesc' },
        { condition: deliveryPricePreIndex && !subsidyCheckItemDesc && !subsidyPreIndex, value: 'deliveryPricePreIndex' },
      ].find(item => item.condition)?.value || '';
      const remarksHtml = {
        subsidyPreIndex: `<div class="delivery-price">
          <span class="delivery-price-label" style="color: #0F9B43;">${subsidyPreIndex}</span><span>¥</span><span class="delivery-price-value" tag="deliveryPriceValue">${_deliveryPrice}</span>
        </div>`,
        subsidyCheckItemDesc: `<div class="delivery-price">
          <span class="delivery-price-label" style="color: #0F9B43; white-space: nowrap;">${subsidyCheckItemDesc}</span>
        </div>`,
        deliveryPricePreIndex: `<div class="delivery-price">
          <span class="delivery-price-label">${deliveryPricePreIndex}</span><span>¥</span><span class="delivery-price-value" tag="deliveryPriceValue">${_deliveryPrice}</span>
        </div>`,
      }
      // 没有对应字段 不展示价格附注信息
      return remarksHtml?.[htmlKey] || '';
    }

    getCheckbox(){
        // let arrChecked = false
        // this._model._gift&&this._model._gift._data.map((item, index) => {
        //     if(item.stock >= 1 && item.stock < this._model._count){
        //         arrChecked = true
        //     }
        // })
        //套餐主品没有checkbox
        if(this._model._parent._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE){
            return ``;
        }
        //失效商品
        if(this._model._invalid){
            return ``;  
        }
        //有效商品，但是无法选中
        if(this._model._purchaseEnable == false && this._model._invalid == false){
            return `<i  tag='setActiveInvalid' class="iconfont icon-disabled item_checkbox ${_engine._editStatus?"is-not-edit":"isedit"}"></i>
            <i tag='setEditActive' class="iconfont ${this._model._isChecked_fake?"icon-checked":"icon-uncheck"} item_checkbox ${_engine._editStatus?"isedit":"is-not-edit"}"></i>`;  
        }
        if(this._model._isChecked){
            return `<i tag='setActive' class="iconfont icon-checked item_checkbox isedit"></i>`;
            // <i tag='setEditActive'  class="iconfont icon-uncheck item_checkbox ${_engine._editStatus?"isedit":"is-not-edit"}"></i>`; 
        }else{
            return `<i  tag='setActive' class="iconfont icon-uncheck item_checkbox isedit"></i>`;
            //<i tag='setEditActive' class="iconfont icon-uncheck item_checkbox ${_engine._editStatus?"isedit":"is-not-edit"}"></i>`; 
        }        
    }

    getReduceBtnDisabled(){
        if(this._model._count == 1){
            return "disabled";
        }
        return "";
    }

    getMaxBtnDisabled(){
        if(this._model._count >= this._model.getMaxBuyCount()){
            return "disabled";
        }
        return "";
    }

    getMainSkuImg(){
        let html = "";
        if(!this._model._invalid){
            html =`<div class="i_img">   
                    <a href="${this._model._link}" >                
                        <img tag='mainsku_img' src="${this._model._img}" alt="">    
                    </a>               
                </div>`;
        }else if(this._model._price == "暂无报价"){
            html = `<div class="i_img">
                <img src="${this._model._img}" alt="">
                <div class="already_sold_box">
                    <p class="sold_texts"> </p>                
                </div>                
            </div>`;
        }else{
            let msg = this._model.getInvalidMsg();
            if(msg){
                html = `<div class="i_img">
                <img src="${this._model._img}" alt="">
                <div class="already_sold_box">
                    <p class="sold_text">${msg}</p>                
                </div>                
            </div>`;
            }else{
                html = `<div class="i_img">
                <img src="${this._model._img}" alt="">
                <div class="already_sold_box">
                    <p class="sold_texts"> </p>                
                </div>                
            </div>`;
            }
           
        }
        return html;
    }
    getInvalidMsg(){
        if(this._model._invalid){
            return this._model._stock<=0?Constant.MSG.NOSTOCK:Constant.MSG.INVALID;
        }else{
            return "";
        }
    }

    getCountBtn() {       
        //已售罄
        if(this._model._invalid && this._model._stock <= 0){
            return "";
        }
        //已下架
        if(this._model._invalid && this._model._marketable == false){
            return "";
        }

        if(this._model._purchaseEnable == false){
            return `<input type="button" disabled value="-" class="reduce">
            <input class="num" disabled  value="${this._model._count}" type="text">
            <input type="button" disabled value="+" class="add">`;
        }
        //其他
        return `<input type="button" ${this.getReduceBtnDisabled()} value="-" class="reduce" tag='mainskureduce'>
            <input class="num" readonly tag='mainsku_count'  value="${this._model._count}" type="text">
            <input type="button" ${this.getMaxBtnDisabled()} value="+" class="add" tag='mainskuadd'>`;
    }

    getMainSkuPriceAndOp(){
        let html = "";
        //套餐 wap端特殊处理结构和PC不一样
        // console.log(this._model,'wap端商品数据')
        if (this._model._parent._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE) {
            html = `
                <div class="i_quantity" style="opacity:${(this._model._invalid ) ? '0.5' : '1'};">
                    <span class="a_suit">1件/套</span> x <span class="a_num" tag='mainsku_count' >${this._model._count}</span>
                </div>`;
        }else{
            if(!this._model._invalid){
                html = `
                <div class="price_num">
                    <div class="i_price">
                    <p style="padding-top: 10px">${this.getBookingInfo()}</p>
                    ${this.handlePriceRemarks()}
                    </div>
                    <div class="i_quantity">
                    <p class="le_num_action">
                        ${this.getCountBtn()}
                    </p>
                    <p class="le_color_red limit_tip" tag="mainsku_purchaseMsg">${(this._model._invalid) || (this._model._purchaseEnable == false && this._model._invalid == false) ? '' : this._model._purchaseMsg}</p>
                    </div>
                <div>`;
            } else if(this._model._price == "暂无报价"){
                let _findSimilar = "";
                if(window._shopId == 1){
                    _findSimilar = `<button class="find_similar" tag="find_similar">找相似</button>`;
                }
                html = `
                <div class="price_num">
                    <div class="i_price">
                    <p style="padding-top: 10px"><span>¥</span>${this._model._price}</p>
                    </div>
                    <div class="i_action">
                        ${_findSimilar}
                      </div>
                <div>`;
            }else{
                let _findSimilar = "";
                if(window._shopId == 1){
                    _findSimilar = `<button class="find_similar" tag="find_similar">找相似</button>`;
                }
                html = `
                <div class="price_num" style="position: relative">
                    <div class="i_price">
                    <p style="padding-top: 10px"><span>¥</span>${this._model._price}</p>
                    ${this.handlePriceRemarks()}
                    </div>
                    <div class="i_action" style="display:flex; position: absolute; right: 0">
                        <button tag="stock_tip" data-code="${this._model._id}" data-name="${this._model._name}"  style="color:#454545;display:${ (this._model._marketable == true  && this._model._stock <= 0) ?'block':'none'}" data-url="${this._model._link}">到货提醒</button>
                        ${_findSimilar}
                      </div>
                <div>`;

            }
        }
        return html;        
    }

    interceptList(){
        // 监听视图数据实时更新

        //image
        let imgEl = $(this._el).find("[tag=mainsku_img]");
        new Intercept().init(imgEl, this._model, "_img");
        //name
        let nameEl = $(this._el).find("[tag=mainsku_name]");
        new Intercept().init(nameEl, this._model, "_name");
        //addprice
        let addpriceEl = $(this._el).find("[tag=mainsku_addprice]");
        if(this._model._parent._itemType != Constant.GROUP_TYPE.PACKAGE.TYPE && this._model._addPrice){
            new Intercept().init(addpriceEl, this._model, "_addPrice");
        }
        //count
        let countEl = $(this._el).find("[tag=mainsku_count]");
        new Intercept().init(countEl, this._model, "_count");
        
        // //total wap端 不显示小计
        // let totalPriceEl = $(this._el).find("[tag=mainsku_totalprice]");
        // new Intercept().init(totalPriceEl, this._model, "_totalPrice");
        // checked
        let checkedEl = $(this._el).find("[tag=setActive]");
        if(checkedEl){
            new Intercept().init(checkedEl, this._model, "_isChecked",'cls',"icon-checked","icon-uncheck");
        }
        
        //_purchaseMsg
        let purchaseMsg = $(this._el).find("[tag=mainsku_purchaseMsg]");
        new Intercept().init(purchaseMsg, this._model, "_purchaseMsg");

        //_hasCoupons
        let Coupon = $(this._el).find("[tag=mainskuSelectCoupon]");
        new Intercept().init(Coupon, this._model, "_hasCoupons", 'show');
        //_hasServices
        let Services = $(this._el).find("[tag=mainskuSelectService]");
        new Intercept().init(Services, this._model, "_hasServices", 'show'); 

        // wap编辑状态下的复选框
        let editCheckBoxEl = $(this._el).find("[tag=setEditActive]");
        if(editCheckBoxEl){
            _engine._wapIsEditIntercept.addObserver(editCheckBoxEl,'cls',"isedit","is-not-edit");
            new Intercept().init(editCheckBoxEl, this._model, "_isChecked_fake",'cls',"icon-checked","icon-uncheck"); 
        }
        // if(checkedEl){
        //     _engine._wapIsEditIntercept.addObserver(checkedEl,'cls',"is-not-edit","isedit");
        // }
        // checkedInvalid
        let checkedInvalidEl = $(this._el).find("[tag=setActiveInvalid]");   
        if(checkedInvalidEl){
            _engine._wapIsEditIntercept.addObserver(checkedInvalidEl,'cls',"is-not-edit","isedit");
        }    

        const goodsDeliveryPriceEl = $(this._el).find("[tag=deliveryPriceValue]");
        if(goodsDeliveryPriceEl) {
          new Intercept().init(goodsDeliveryPriceEl, this._model, "_deliveryPrice");
        }
    }

    render(){
        let parentEl = $(this._model._parent._view._mainSkuBoxEl);
        this._headerBoxEl = this._model._parent._view._headerBoxEl;
        this._extraBoxEl = this._model._parent._view._extraBoxEl;
        const goodsPresellType = this._model && this._model._data && this._model._data.presellType; // 商品预售类型  普通预售：0  候补：1
        // let tmpId = this._model._id + '_' +this._model._parent._itemId;
        let tmpId = this._model._id + '_' + (this._model._parent._itemId == "" ? this._model._itemId:this._model._parent._itemId)
        let sku = '';
        if(this._model._isHours){
            sku += `
            <div class="xiaoshidaWrap" >               
            </div>
            `;
        }
        sku += `<!-- checkbox -->
        <div class='clearfix form' skuid=${tmpId}>`;
        // if(!this._model._invalid) {
            sku += `<div class="i_checkbox">
                ${this.getCheckbox()}
            </div>`;
        // }
            
            sku += `<!-- img -->
            ${this.getMainSkuImg()}
            <!-- form_right -->
            <div class="form_right">
                <!-- MainSku desc -->
                <div class="i_desc" >                    
                    <div class="title_box">
                      <h3 tag="mainsku_name" class='mainsku_name'><a class="goods_selltype" preselltype=${goodsPresellType} href="${this._model._link}" >${this._model._name}</a></h3>
                      <p style="display:${!this._model._invalid && this._model._hasCoupons ? 'inline-block' : 'none'}" tag='mainskuSelectCoupon'>领券</p>
                    </div>
                    <p class="service_box" style='display:${!this._model._invalid && this._model._hasServices ?'inline-block':'none'}' tag='mainskuSelectService' > 
                      <button>${this._model._service && this._model._service._data.length > 0 ? '<span>修改服务</span>' : '<span>选择服务</span>'}<i class="iconfont icon-arrow-down le_vertical_align_m"></i></button>
                    </p>    
                    <p class="option_box" style='display:${!this._model._invalid && this._model._hasOptions ?'inline-block':'none'}' tag='mainskuSelectOption' > 
                      <button>${this._model._option && this._model._option._data && this._model._option._data.length > 0? '<span>修改选件</span>' : '<span>选择选件</span>'}<i class="iconfont icon-arrow-down le_vertical_align_m"></i></button>
                    </p>    
                               
                </div>
                <!-- 比加入时降价 -->                
                    ${this.getAddPrice()}
                <!-- 预售定金抵扣 -->                
                    ${this.getDeduction()}
                <!-- 价格 -->
                ${this.getMainSkuPriceAndOp()}
            </div>
            <!-- end form_right -->
        </div>`;
        if(this._model._parent._itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE){
            sku = `<div class='content_item ${this._model._isChecked ?'active':''}'>
                    <div class='good_item_head_box promotion'></div>
                    <div class='good_main'>
                        ${sku}
                        </div>
                        </div>
                        <div class='extra extraCls'></div>
                    </div>
                </div>`;
        }
        parentEl.append($(sku));
        this._el = $("div[skuid='"+tmpId+"']");
        if(this._model._parent._itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE){
            this._fullMainSkuEl = this._el.parent('div.good_main');
        }
        if(this._model._parent._itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE){
            this._headerBoxEl = this._el.parents('div.content_item').find('.promotion');
            this._extraBoxEl = this._el.parents('div.content_item').find('.extraCls');
        }
        //套餐容器
        if (this._model._parent._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE) {
            this._packageBoxEl = this._el.parents('div.content_item').find('.packageBox');
        }
        this._serverBoxEl = $('div.service_wrapper');
        this._couponBoxEl = $('div.coupon_wrapper');
        this._optionBoxEl = $('div.option_wrapper');
        this._optionBoxEls = $('div.option_wrappers');
        this._giftBoxEl = $('.receive_wrapper');
        this._similarityBoxEl = $('.similarity_wap_wrapper');
        // this._arrivalgoodsBoxEl = $('.subscribe_mask');
        //检查主品是否可用
        if (this._model._invalid) {
            if (this._model._parent._itemType != Constant.GROUP_TYPE.FULL_REDUCE.TYPE) {
                this._model._parent._view._el.addClass('alreadly_sold');
            } else {
                this._el.parents('div.content_item').addClass('alreadly_sold');
            }
        }
        this.interceptList();
        this.regEvent();
        this.registerEvent();
    }

    removeItem(){
        let params = {
            itemIds:this._model._parent._itemId,
            terminal:_terminal,
            shopId:_shopId
        }
        API.removeItem(params).then(x=>{
            //价格变动
            $event_publisher.broadcast(Constant.EVENT_KEY.PRICE, x.t);
            //通知Group，里面有MainSku被删除
            $event_publisher.broadcast(Constant.EVENT_KEY.REMOVE_MAINSKU, this._model);
            //检测购物车是否还有商品
            _engine._price._view.checkCartEmpty();
        }).catch(err=>{
            alert(err.msg);
        })
    }

    clearExtraBox(){
        this._extraBoxEl.html("");
        this._packageBoxEl && this._packageBoxEl.html("");
    }

    modifyCount(count){
        return new Promise((reslove,reject)=>{
            let params = {
                itemId:this._model._itemId,
                terminal:_terminal,
                shopId:_shopId,
                icount:count,
                // optionId:1
            }
            API.modifyCount(params).then(x=>{
                //价格变动
                $event_publisher.broadcast(Constant.EVENT_KEY.PRICE, x.t);
                //重新设置MainSku的属性 + 重新渲染附属商品
                $event_publisher.broadcast(Constant.EVENT_KEY.MODIFY_COUNT, {model:this._model, data:x.t});
                reslove();
            }).catch(err=>{
                reject();
                alert(err.msg);
            })
        })
    }

    regEvent(){
        let that = this;
        //选择服务
        this._el.off("click", "p.service_box").on("click", "p.service_box", function () {
           
            that._model.getServiceList().then(
                x=>{
                    that._model._serviceGoods._view.render();
                    $('div.service_wrapper').css('display','flex');  
                    $util.toggleBodyScroller(true);
                }
            ).catch(err => { 
                Alert.showTip(err);
            });              
        })
        //选择选件
        this._el.off("click", "p.option_box").on("click", "p.option_box", function () {           
            that._model.getOptionGoods().then(
                x=>{                       
                    that._model._optionList._view.render();
                    $('div.option_wrapper').show();    
                    $util.toggleBodyScroller(true);            
                }
            ).catch(err=>{
                $('div.option_wrappers').show();  
                $util.toggleBodyScroller(true);
                $(".option_Title").html(`选择选件<i class="fr iconfont icon-close" tag="optionhide"></i>`)
                $(".optionsNone_text").html(`暂无选件`)  
            });
        })
        //选择优惠券
        this._el.off("click", "div.title_box p").on("click", "div.title_box p", function () {           
                       
                that._model.getCouponList().then(
                    x=>{
                        that._model._coupon._view.render();
                        $('div.coupon_wrapper').show();   
                        $util.toggleBodyScroller(true);             
                    }
                );
        })
       
        //减少数量
        this._el.off("click", "input[tag='mainskureduce']").on("click", "input[tag='mainskureduce']", function () {
            let count = parseInt(that._model._count) - 1;
            if (count < that._model.getMaxBuyCount()){
                $(that._el).find("input[tag='mainskuadd']").removeAttr("disabled");
            }
            that._model.modifyCount(count).then(() => {
                if (count == 1) {
                    $(this).attr("disabled", true);
                }
            }).catch(err => { 
                Alert.showTip(err);
            });
        })

        //增加数量
        this._el.off("click", "input[tag='mainskuadd']").on("click", "input[tag='mainskuadd']", function () {
            $(that._el).find("input[tag='mainskureduce']").removeAttr("disabled");
            let count = parseInt(that._model._count) + 1;
            that._model.modifyCount(count).then(() => {
                if (count == that._model.getMaxBuyCount()) {
                    $(this).attr("disabled", true);
                }
            }).catch(err => { 
                Alert.showTip(err);
            });
        })
        // 点击找相似find_similar
        this._el.off("click", ".find_similar").on("click", ".find_similar", function () {
            that._model.getSimilarityGoods().then(
                x=>{
                    that._model._similarityGoods._view.render();
                    $('div.similarity_wap_wrapper').show();    
                    $util.toggleBodyScroller(true);            
                }
            );
        })
        //激活
        this._el.off("click", "i[tag='setActive']").on("click", "i[tag='setActive']", function () {
            that._model.setActive().then().catch(err => { 
                Alert.showTip(err);
            });
        })
        //wap编辑状态下选中
        this._el.off("click", "i[tag='setEditActive']").on("click", "i[tag='setEditActive']", function () {
            that._model.setFakeActive();           
        })
        // 点击到货提醒,弹出弹窗
        this._el.off("click", ".price_num button[tag='stock_tip']").on("click", ".price_num button[tag='stock_tip']", function () {
            let url = $(this).attr('data-url');
            let code = $(this).attr('data-code');
            let name = $(this).attr('data-name');
            let _obj = [{
                linkAddress: url,
                code: code,
                name: name
            }];
            $('.subscribe_mask').show();
            that._model.getArrival(_obj);
            that._model._arrivalGoods._view.render();
            $util.toggleBodyScroller(true);
        })
        // 点击到货提醒,弹出弹窗
        this._el.parent().off("click", ".xiaoshidaWrap").on("click", ".xiaoshidaWrap", function () {  
            var wapua = navigator.userAgent;
            var isAndroid = wapua.indexOf('Android') > -1 || wapua.indexOf('Adr') > -1; //android终端
            var isiOS = !!wapua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            var android_schema = "lclubapp://lclub.mobile";
            var ios_schema = 'lenovoclub://lclub.mobile';    
            var browser = {
                versions:function(){
                    var u = navigator.userAgent, app = navigator.appVersion;
                    return {
                        trident: u.indexOf('Trident') > -1, //IE内核
                        presto: u.indexOf('Presto') > -1, //opera内核
                        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
                        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                        android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
                        iPhone: u.indexOf('iPhone') > -1 , //是否为iPhone或者QQHD浏览器
                        iPad: u.indexOf('iPad') > -1, //是否iPad
                        webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
                        weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
                        qq: u.match(/\sQQ/i) == " qq" //是否QQ
                    };
                }()
            };      
           
            var ua = navigator.userAgent.toLowerCase();
            if (browser.versions.mobile) {
                if (ua.match(/WeiBo/i) == "weibo") {
                    return;
                }else if(ua.match(/biLiApp/i) == "biliapp" || ua.match(/ sobot/i) == " sobot") {
                    return;
                }else if(ua.match(/meituangroup/i) == "meituangroup") {
                    return;
                }else if(ua.match(/com.dianping.v1/i) == "com.dianping.v1" || ua.match(/com.dianping.dpscope/i) == "com.dianping.dpscope") {
                    return;
                }else if(ua.match(/com.lenovo.leos.appstore/i) == "com.lenovo.leos.appstore") { //乐商店
                    return;
                }
                else if(ua.match(/duapp/i) == "duapp") { //得物（毒）app
                    return;
                }
                else if(ua.match(/lenovoshopmobile/i) == "lenovoshopmobile") { //智慧联想app
                    return;
                }
            }
    
            if (isAndroid) {
                if (browser.versions.webKit) { // 谷歌浏览器内核
                    var elementLink = document.createElement("a");
                    elementLink.setAttribute("href", android_schema + '?type=apptab&value=3');
                    elementLink.style.display = "none";
                    document.body.appendChild(elementLink).click();                    
                } else {
                    var ifr = document.createElement("iframe");
                    ifr.style.display = "none";
                    ifr.src = android_schema +'?type=apptab&value=3';
                    document.body.appendChild(ifr);
                }
            } else if (isiOS) {                
                location.href = ios_schema +'?type=apptab&value=3';                        
            }   
            setTimeout(function () {
                document.body.removeChild(elementLink);
                // if (Date.now() - last > 1100) {
                //     window.location.href = 'https://mclub.lenovo.com.cn/downloadapp?type=apptab&value=3';
                // }
                window.location.href = 'https://mclub.lenovo.com.cn/downloadapp?type=apptab&value=3';
            }, 3000);         
        
        })
        
    }
    registerEvent(){
        let that = this;
        let eventNams = ["click","blur"];
        eventNams.forEach(ename=>{
            let tmp = "le" + ename;
            this._el.find("["+tmp+"]").each((index, item)=>{
                let eventHandlerName = $(item).attr(tmp);
                (function(dom, eventHandlerName){
                    $(dom).on(ename, function(){
                        that._eventCenter[eventHandlerName](this, {view:that})
                    });
                })(item, eventHandlerName);
            })
        })
    }
}
class MainSkuEvent{
    
}